<template>

    <div class="w-full 
                relative
                cursor-pointer
                select-none"

    :class="{
        'opacity-75': disabled,
        'pointer-events-none': disabled
    }"

    >

        <label class="text-xs block tracking-widest py-2" v-if="label" >{{label}}*</label>
    
        <!-- Select head -->

        <div class="w-full 
                    px-2
                    flex
                    text-sm
                    relative
                    items-center 
                    cursor-pointer
                    border-solid
                    border-gray-400
                    rounded-md" 
        
        :style="computedHeight"
        :class="{
            'bg-white': !naked,
            'border': !naked,
        }" 

        @click.stop="openList = !openList"
        
        >

            <p class="mr-2" v-if="prefix" >{{ prefix }}</p>

            <p 
            
            class="truncate text-gray-500"

            :class="{
                'flex-grow': !naked,
                'font-bold': input ? input.length > 0 : false,
                'text-ch-blue': input ? input.length > 0 : false,
                'text-ch-light-blue': (input ? input.length > 0 : false) && color
            }"
            
            >
            
                {{ input ? input.length > 0 ? input.map( v => v.name ).join(', ') : placeholder : placeholder }}
                
            </p>

            <p v-if="showCount" :class="{ 'text-yellow-500': color }" >
                
                <span class="text-green-500" v-if="multiple" >{{ selectedList.length }}</span> 
                <span v-if="multiple" >/</span> 
                {{ count }}
                
            </p>

            <img src="/images/icons/arrow-black-small.svg" alt="arrow" >

        </div>

        <!-- Select body -->

        <div class="w-full 
                    absolute 
                    left-0
                    z-30 
                    bg-white 
                    shadow-xl 
                    rounded-md
                    overflow-hidden
                    transition-height"
                     
        :style="computedListStyles"
        :class="{ 'duration-200': openList }"

        v-out="closeList"
        
        >

            <transition-group 
            
            tag="div"
            name="show-list" 
            
            :style="computedListStyles" 
            :class="{ 'overflow-y-auto': list ? list.length > 4 : false }" 
            
            >

                <!-- Select body item -->

                <div class="h-11
                            px-4
                            flex
                            text-sm
                            items-center
                            hover:bg-gray-100"
                
                :key="index" v-for="(item, index) in list"
                :selected="selectedList.map( i => i.id ).includes(item.id)"
                :class="{ 'font-bold': selectedList.map( i => i.id ).includes(item.id) }"

                v-show="openList"

                @click="selectItem(item)"
                
                >

                    <p class="flex-grow" >{{ item.name }}</p>

                    <img 
                    
                    alt="checkmark"
                    src="/images/icons/check-green.svg" 
                    
                    :class="{ 'opacity-25': !selectedList.map( i => i.id ).includes(item.id) }"

                    >

                </div>

            </transition-group>

        </div>

    </div>

</template>

<script>

    import { ref, watch, computed, onMounted } from 'vue'

    import { out } from '../assets/scripts/clickOutside'

    export default {
    
        name: 'Select',

        props: {

            // list prop must recive Array of objects eg: [{ id: 1, name: Item }]

            list: Array,
            label: String,
            color: Boolean,
            naked: Boolean,
            prefix: String,
            modelValue: Array,
            multiple: Boolean,
            disabled: Boolean,
            showCount: Boolean,
            preselected: Boolean,
            height: { type: Number, default: 48 },
            placeholder: { type: String, default: 'Select Item' }

        },

        setup( props, { emit }) {

            const count = computed(() => props.list ? props.list.length : 0 )
            const computedHeight = computed(() => `height: ${props.height}px` )

            // List 

            const openList = ref(false)
            const closeList = () => { openList.value = false }

            const computedListStyles = computed(() => { 
                
                return  `top: ${ props.label ? props.height + 45 : props.height + 5 }px;` +
                        `height: ${ ( props.list && openList.value ) ? props.list.length > 4 ? 176 : ( 44 * props.list.length ) : 0 }px;` 
            
            })

            const selectedList = ref([])

            const input = computed({
                get: () => props.modelValue,
                set: value => emit( 'update:modelValue', value )
            })

            const selectItem = (item) => {

                if ( props.multiple ) {

                    if ( selectedList.value.map( i => i.id ).includes( item.id ) ) {

                        selectedList.value = selectedList.value.filter( i => i.id != item.id )

                    }

                    else {

                        selectedList.value.push( item )

                    }

                }

                else {

                    if ( selectedList.value.map( i => i.id ).includes( item.id ) ) {

                        selectedList.value = []

                    }

                    else {

                        selectedList.value = []
                        selectedList.value.push(item)

                    }

                }

                emit( 'update:modelValue', selectedList.value )

            }

            const preselectItem = () => {

                if ( props.preselected ) {

                    selectedList.value.push( props.list[0] )

                    emit( 'update:modelValue', selectedList.value )

                }

            }

            onMounted( preselectItem )

            watch( input, () => { selectedList.value = input.value }, {immediate: true})

            return {
                count,
                input,
                openList,
                closeList,
                selectItem,
                selectedList,
                computedHeight,
                computedListStyles
            }

        },

        directives: { out }

    }

</script>

<style scoped>

    .show-list-enter-active, .show-list-leave-active {

        transition: 0.5s;
    }

    .show-list-leave-to {

        transform: translateY(-2rem);
        opacity: 0;
    }

    .show-list-enter-from {

        transform: translateY(2rem);
        opacity: 0;
    }

</style>